<ng-container *ngFor="let tag of state.tags; trackBy: trackByFn">
  <alliance-clubs-tags-item [tag]="tag"></alliance-clubs-tags-item>
</ng-container>
